import _ from 'lodash';
import jsonSchemaUtils from '@wix/wix-json-schema-utils';
import { getWidgetId, getDevCenterWidgetId } from '../../utils/widgetUtils';
import { getSupportedFieldTypesByPropType } from '../../utils/dataBindingUtil';
function getBindingSection(propertyTitle, propertyName, supportedFieldTypes) {
    return {
        title: `Connect ${propertyTitle}`, // TODO: localize https://jira.wixpress.com/browse/WBL-2916
        prop: propertyName,
        supportedFieldTypes,
        supportsReferenceFields: true,
    };
}
function getBindingDefinitionsHelper(panelProps, bindings, widgetName) {
    return {
        panel: {
            height: panelProps?.height ?? 467,
            title: panelProps?.title ?? 'Connect Widget', // TODO: localize https://jira.wixpress.com/browse/WBL-2916
            helpId: panelProps?.helpId ?? 'f3e95690-e2c0-4172-bd5f-f6b77335279d',
        },
        sections: [
            {
                role: 'widgetRole',
                bindings: bindings ?? [],
            },
        ],
        componentName: widgetName,
    };
}
// Used by Bob apps
export async function getBindingDefinitions({ componentRef, editorSDK, panelProps, widgetsProperties, }) {
    const widgetId = await getDevCenterWidgetId(editorSDK, componentRef);
    const widgetProps = widgetsProperties[widgetId];
    const bindings = _.reduce(widgetProps, (res, property, propertyName) => {
        const supportedFieldTypes = getSupportedFieldTypesByPropType(getPropertiesSchemaBindingType(property.type));
        if (!_.isEmpty(supportedFieldTypes)) {
            res.push(getBindingSection(property.title || propertyName, propertyName, supportedFieldTypes));
        }
        return res;
    }, []);
    return getBindingDefinitionsHelper(panelProps, bindings);
}
// used by UEA
export async function getBindingDefinitionsByAppDescriptor({ editorSDK, componentRef, appDescriptor, panelProps, }) {
    const widgetId = await getWidgetId(editorSDK, componentRef);
    const { propertiesSchemas } = appDescriptor.widgets[widgetId].widgetApi;
    const { customDefinitions } = appDescriptor;
    const { name: widgetName } = appDescriptor.widgets[widgetId];
    const bindings = propertiesSchemas?.reduce((arr, property) => {
        const schemaDriver = jsonSchemaUtils.createDriver(customDefinitions);
        schemaDriver.set.schema(property.structure);
        if (!schemaDriver.check.isArray() && !schemaDriver.get.properties()) {
            const propertyName = schemaDriver.get.name();
            const propertyTitle = schemaDriver.get.title() || propertyName;
            const supportedFieldTypes = getSupportedFieldTypesByPropType(getPropertiesSchemaBindingType(schemaDriver.get.type()));
            arr.push(getBindingSection(propertyTitle, propertyName, supportedFieldTypes));
        }
        return arr;
    }, []);
    return getBindingDefinitionsHelper(panelProps, bindings, widgetName);
}
function getPropertiesSchemaBindingType(type) {
    const map = {
        boolean: 'bool',
        text: 'string',
    };
    return map[type] || type;
}
//# sourceMappingURL=binding.js.map